/**
 * @file コンポーネント：ポップアップ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Popup = (props) => {
    /**
     * 変数定義
     */
    const refPopup = useRef(null); // ポップアップ

    /**
     * 初期表示位置調整
     */
    useEffect(() => {
        if (refPopup !== null && refPopup.current !== null) {
            if (props.position === "bottom") {
                // bottom指定時、StyledComponentで指定したbottom値をtop値で置き換える
                const popupStartPositionTop =
                    refPopup.current.getBoundingClientRect().top;
                refPopup.current.style.top = popupStartPositionTop + "px";
                refPopup.current.style.bottom = "initial";
            }
        }
    }, [refPopup, props.position]);

    /**
     * ポップアップを移動する処理
     */
    const [isDrag, setIsDrag] = useState(false);
    // onMouseMove時
    const fnOnMouseMove = (e) => {
        if (isDrag) {
            const x = e.clientX;
            const y = e.clientY;
            const width = refPopup.current.offsetWidth;
            refPopup.current.style.top = y - 24 + "px";
            refPopup.current.style.left = x - width / 2 + "px";
        }
    };

    /**
     * ポップアップの前後位置調整処理
     */
    const [popupZIndex, setPopupZIndex] = useState(null); // ポップアップのz-index値
    const fnSetPopupZIndex = () => {
        if (refPopup !== null && refPopup.current !== null) {
            const selector =
                "." + refPopup.current.classList.value.split(" ").join(".");
            const arrayPopup = Array.from(document.querySelectorAll(selector));
            const arrayPopupZIndex = arrayPopup.map((popup) => {
                return Number(
                    window.getComputedStyle(popup as HTMLElement).zIndex
                );
            });
            setPopupZIndex(Math.max(...arrayPopupZIndex) + 1);
        }
    };
    useEffect(() => {
        if (props.isOpen === true) {
            fnSetPopupZIndex();
        }
    }, [props.isOpen]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnMouseMove={fnOnMouseMove}
            fnSetPopupZIndex={fnSetPopupZIndex}
            popupZIndex={popupZIndex}
            refPopup={refPopup}
            setIsDrag={setIsDrag}
        />
    );
};
